export enum DataProcessingCategoryEnum {
    ServiceOfLegalDocumentsAndTracingOfIndividuals = 1,
    Tracing = 2,
    ServiceOfLegalDocuments = 3
}
